import React, { useState, useEffect } from "react";
import Footer from "./Footer";
import truck from "../../assets/bgtruck.svg";
import logo from "../../assets/Logo.svg";
import fb from "../../assets/fb.svg";
import twitter from "../../assets/twitter.svg";
import linkedin from "../../assets/linkedin.svg";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const Cookies = () => {
  const navigate = useNavigate();
  const [cookiesPolicy, setCookiesPolicy] = useState("");
  const [loading, setLoading] = useState(false);

  
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  useEffect(() => {
    getCookiesPolicy();
  }, []);

  const getCookiesPolicy = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
         `${BASE_URL}/static/getCookiesPolicy`, 
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setCookiesPolicy(response.data?.data?.description || "");
    } catch (error) {
      console.error(
        "API Error (getCookiesPolicy):",
        error.response?.data || error.message
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      {/* Background Section (Navbar + Content) */}
      <div
        className="relative flex flex-col bg-cover bg-center bg-fixed text-white"
        style={{ backgroundImage: `url(${truck})` }}
      >
        {/* Global dark overlay to make text pop */}
        <div className="absolute inset-0 bg-black/80 z-0"></div>

        {/* Content wrapper */}
        <div className="relative z-10 flex flex-col flex-grow">
          {/* Top Navbar */}
          <div className="w-full flex flex-col sm:flex-row justify-between items-center px-4 sm:px-12 py-8">
            {/* Social Icons */}
            <div className="flex gap-5 text-white text-lg sm:text-xl mb-4 sm:mb-0">
              <img src={twitter} alt="Twitter" className="cursor-pointer w-6 h-6 hover:scale-110 transition-transform opacity-80 hover:opacity-100" />
              <img src={fb} alt="Facebook" className="cursor-pointer w-6 h-6 hover:scale-110 transition-transform opacity-80 hover:opacity-100" />
              <img src={linkedin} alt="LinkedIn" className="cursor-pointer w-6 h-6 hover:scale-110 transition-transform opacity-80 hover:opacity-100" />
            </div>

            {/* Logo */}
            <Link to="/" className="text-white font-bold text-xl sm:text-2xl tracking-wider">
              <img src={logo} alt="Logo" className="w-[180px] sm:w-[220px] h-auto mx-auto drop-shadow-lg" />
            </Link>

            {/* Buttons */}
            <div className="flex gap-4 mt-4 sm:mt-0">
              <button
                onClick={() => navigate("/login")}
                className="bg-purple-600 hover:bg-purple-700 text-white px-6 sm:px-10 py-3 rounded-full font-bold transition-all shadow-lg hover:shadow-purple-500/30"
              >
                Log In
              </button>
              <button
                onClick={() => navigate("/signup")}
                className="bg-white/10 hover:bg-white/20 border border-white/20 backdrop-blur-md text-white px-6 sm:px-10 py-3 rounded-full font-bold transition-all"
              >
                Sign Up
              </button>
            </div>
          </div>

          {/* Main Content Area */}
          <div className="flex-grow flex flex-col items-center px-4 sm:px-8 py-12 sm:py-20">
            <div className="max-w-5xl w-full">
              <h1 className="text-[42px] sm:text-[72px] font-inter font-extrabold text-center mb-4 drop-shadow-2xl">
                Cookies Policy
              </h1>
              <p className="text-gray-300 text-center text-lg sm:text-2xl mb-12 max-w-2xl mx-auto">
                {loading ? "Loading content..." : "Learn about how we use cookies to improve your experience."}
              </p>

              {/* Content Card with Glassmorphism */}
              <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-[40px] shadow-2xl p-8 sm:p-14 md:p-20 mb-20">
                {loading ? (
                  <div className="flex justify-center py-20">
                    <div className="w-12 h-12 border-4 border-purple-500 border-t-transparent rounded-full animate-spin"></div>
                  </div>
                ) : (
                  <div
                    className="text-[16px] sm:text-[19px] leading-[1.9] text-gray-200 space-y-8 prose-custom"
                    dangerouslySetInnerHTML={{ __html: cookiesPolicy }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Cookies;
